import { FaArrowCircleRight } from "react-icons/fa";

interface AutomationTemplateCardProps {
  template: any;
  onSelect: (template: any) => void;
}

export const AutomationTemplateCard = ({ template, onSelect }: AutomationTemplateCardProps) => {
  return (
    <div
      style={{
        display: "contents",
      }}
    >
      <div
        onClick={() => onSelect(template)}
        className="automation-template-card cursor-pointer border border-gray-200 rounded-lg p-4 hover:shadow-md transition-all duration-300 w-full hover:bg-gray-50 hover:border-gray-300 hover:shadow-md hover:dark:bg-gray-900 hover:dark:border-gray-700 hover:dark:shadow-md dark:border-gray-700 dark:bg-gray-800"
      >
        <div className="automation-template-card-header text-md font-bold mb-4 flex items-center justify-between">
          <span className="flex items-center gap-2 text-md font-bold">
            {template.image}
            Быстрый старт
          </span>
          <button className="rounded-full hover:bg-gray-100">
            <FaArrowCircleRight size={20} color="gray" />
          </button>
        </div>
        <div className="text-lg font-bold">{template.name}</div>
        <p className="text-sm text-gray-500 mb-4">{template.description}</p>
      </div>
    </div>
  );
};
